import './BattleMenu.css';
import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import Helper from "../../../services/Helper";

function GiveUp() {
    const {tutorial} = useTypedSelector(state => state.auth);
    const {phase} = useTypedSelector(state => state.game);
    const {setPhase, playerGiveUp, setSystemMessage} = useActions();

    const giveUp = () => {
        setPhase('give_up');
        playerGiveUp();
    }

    let tutorialClasses = '';

    const isTutorialActive =
        tutorial.isActive &&
        Helper.getStepOrder(tutorial.step) < Helper.getStepOrder('BattleFinish80');

    if (isTutorialActive) {
        tutorialClasses = 'gameGiveUpTutorial';
    }

    return <div className={'gameGiveUp' + tutorialClasses}
                onClick={() => {
                    if(phase === 'give_up' || phase === 'end_game'){
                        return;
                    }

                    setSystemMessage({
                        isVisible: true,
                        type: 'dialog',
                        text: 'Are you sure want to surrender?',
                        action: giveUp
                    });
                }}
    >
    </div>
}

export default GiveUp;